import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import queryString from 'query-string';

// components
import { Button, Row, Col, Card, CardBody, Form } from "reactstrap";
import InputPDF from "../../components/Input/InputPDF";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST } from "../../services/api_service.js";

// helpers
import { formateDate, formateDateApi } from "../../helpers/formats.js";

//Context
import { useAuth } from "../../context/auth";

export default function AnexoComprovantePagamento({ history }) {
    const { setLoading} = useAuth();
    const { handleSubmit } = useForm({ mode: "onBlur" });
    const [dadosComprovantePagamento, set_dadosComprovantePagamento] = useState(null)
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        if (params != null && params.hash != null) {
            setLoading(true);
            api_GET(`Requerimento/GetRequerimentoCobranca/${params.hash}`)
                .then(result => {
                    setLoading(false);
                    set_dadosComprovantePagamento(result.data);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }
    useEffect(() => {
        loadDados();
    }, []);

    const [arquivo, set_arquivo] = useState(null);
    const handleFile = (file, callback) => {
        if (file == null) {
            return;
        }

        set_arquivo(file);
        callback();
    }

    const onSubmit = (data) => {
        if (!arquivo) {
            showMessage("Aviso", "Selecione um arquivo para importação!", 'error', null);
            return;
        }

        let json_submit = {
            requerimentoCobranca_Id: dadosComprovantePagamento.requerimentoCobranca_Id,
            dataImportacao: formateDateApi(new Date()),
            arquivo: arquivo.name,
            arquivoBase64: arquivo.base64
        }

        setLoading(true);
        api_POST(`AnaliseRequerimento/PostRequerimentoCobrancaComprovante/${dadosComprovantePagamento.requerimento_Id}`, json_submit)
            .then(result => {
                setLoading(false);
                showMessage("Aviso", "Comprovante enviado com sucesso", 'success', function () {
                    window.location.reload();
                });
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div>
                <Card className="card-stats">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 className="titulo-consulta">Dados do Requerimento</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col lg="8" sm="12">
                                    <p><b>Documento:</b> {dadosComprovantePagamento && dadosComprovantePagamento.requerimento.cpf_Cnpj}</p>
                                </Col>
                                <Col lg="4" sm="12">
                                    <p><b>Tipo Requerimento:</b> {dadosComprovantePagamento && dadosComprovantePagamento.requerimento.setupSolicitacaoAcao.acao}</p>
                                </Col>
                                <Col lg="8" sm="12">
                                    <p><b>Responsável:</b> {dadosComprovantePagamento && dadosComprovantePagamento.requerimento.nomeSolicitante}</p>
                                </Col>
                                <Col lg="4" sm="12">
                                    <p><b>Data Requerimento:</b> {dadosComprovantePagamento && formateDate(dadosComprovantePagamento.requerimento.dataCriacaoRequerimento)}</p>
                                </Col>
                            </Row>
                            {dadosComprovantePagamento && dadosComprovantePagamento.status == "Confirmado" &&
                                <Row className="mb-4">
                                    <Col lg="12">
                                        <h3 className="titulo-consulta">Seu comprovante de pagamento já foi enviado.</h3>
                                    </Col>
                                </Row>
                            }
                            {dadosComprovantePagamento && dadosComprovantePagamento.status == "Pendente" &&
                                <>
                                    <Row className="mb-4">
                                        <Col lg="12">
                                            <h3 className="titulo-consulta">Anexar Comprovante de Pagamento</h3>
                                            <div className="line-protocolo"></div>
                                        </Col>
                                        <Col md="12" lg="12" className="mt-2">
                                            <InputPDF height="4rem" width="4rem" name="comprovantePagamento"
                                                image={null}
                                                documento_id={1}
                                                handlefile={handleFile}>
                                            </InputPDF>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" className="text-center">
                                            <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-check"></i> Enviar Comprovante</Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </CardBody>
                    </Form>
                </Card>
            </div>
        </>
    );
}